var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPillWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stroke-10186 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elements/Sample/Grey",
    transform: "translate(-11.000000, -11.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "badge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8106093,26.4877419 C18.7942652,28.504086 15.5277419,28.504086 13.5113978,26.4877419 C11.4962007,24.4725448 11.4962007,21.2048746 13.5113978,19.1885305 L19.1888172,13.5122581 C21.2040143,11.495914 24.4716846,11.495914 26.4868817,13.5122581 C28.5032258,15.5274552 28.5032258,18.7951254 26.4868817,20.8114695 L20.8106093,26.4877419 Z M16.3494194,16.3506237 L23.6486308,23.6498351 M20.4051613,16.1944414 L20.8111828,15.7884199 C21.9306093,14.6701403 23.7450896,14.6701403 24.8656631,15.7884199",
    id: "Stroke-10186-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillWhite);
export default __webpack_public_path__ + "static/media/icon-pill-white.e5d7daa27095f7a6b266c1e45d3a76a7.svg";
export { ForwardRef as ReactComponent };